import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Una lectura de la pantalla: sus datos, su error y cómo volver a pedirla. Se repite cuando cambia
 * `clave`; la respuesta que llega de una clave anterior se descarta, así no pinta otro día.
 */
export function useLectura<T>(leer: () => Promise<T>, clave: string) {
  const [estado, setEstado] = useState<{ datos: T | undefined; error: unknown; cargando: boolean }>({
    datos: undefined,
    error: null,
    cargando: true,
  });
  const [vuelta, setVuelta] = useState(0);
  const leerActual = useRef(leer);
  leerActual.current = leer;

  useEffect(() => {
    let vigente = true;
    setEstado({ datos: undefined, error: null, cargando: true });
    leerActual.current().then(
      (datos) => vigente && setEstado({ datos, error: null, cargando: false }),
      (error: unknown) => vigente && setEstado({ datos: undefined, error, cargando: false })
    );
    return () => {
      vigente = false;
    };
  }, [clave, vuelta]);

  const recargar = useCallback(() => setVuelta((v) => v + 1), []);
  return { ...estado, recargar };
}
